import { Button } from '@restworld/ui-ds-base';
import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { ModalHeader } from '../common';
import { useSetAtom } from 'jotai';
import { modalOpen, setIsVerificationSuccessful } from './states';
import { FlexCol } from '../header';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export function useEditPhoneNumberSuccessfulContent() {
  const setOpen = useSetAtom(modalOpen);
  const setSuccessfulVerificationContent = useSetAtom(setIsVerificationSuccessful);
  const { t } = useTranslation('user-settings');
  const { t: commonT } = useTranslation('common');
  const header = t('phone_number_modal_phone_number_verified_successful');

  const onClose = useCallback(() => {
    setOpen(false);
    setSuccessfulVerificationContent(false);
  }, [setOpen, setSuccessfulVerificationContent]);

  const editPhoneNumberSuccessfulContent = useMemo(
    () => (
      <div className="flex flex-col items-center">
        <Image src={getAssetSrc('/utils-assets/success-check.svg')} width={64} height={64} alt={header} />
        <FlexCol className="items-center  justify-start mt-2 mb-10 ">
          <ModalHeader>{`${header} 🥳`}</ModalHeader>
        </FlexCol>
      </div>
    ),
    [header]
  );

  const editPhoneNumberSuccessfulFooter = useMemo(
    () => (
      <Button fullwidth={true} onClick={onClose}>
        {commonT('close')}
      </Button>
    ),
    [commonT, onClose]
  );

  return {
    editPhoneNumberSuccessfulContent,
    editPhoneNumberSuccessfulFooter,
  };
}
